import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ChatWidget from '../../components/feature/ChatWidget';

export default function Home() {
  return (
    <div className="min-h-screen relative">
      {/* Full Page Video Background */}
      <div className="fixed inset-0 w-full h-full z-0">
        <video
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          className="absolute inset-0 w-full h-full object-cover"
          onError={(e) => {
            console.log('Video failed to load, showing fallback');
            e.currentTarget.style.display = 'none';
          }}
        >
          {/* John Peterson's Introduction Video - Direct MP4 URL */}
          <source src="https://cdn-user.veed.io/render/premium/59ddfd06-3e0e-492c-8fe8-1d6e088c3a22.mp4" type="video/mp4" />
          
          {/* Fallback videos in case John's video doesn't load */}
          <source src="https://videos.pexels.com/video-files/6853706/6853706-hd_1920_1080_30fps.mp4" type="video/mp4" />
          <source src="https://videos.pexels.com/video-files/3209828/3209828-hd_1920_1080_25fps.mp4" type="video/mp4" />
        </video>
        
        {/* Dark overlay for better content readability */}
        <div className="absolute inset-0 bg-black/40"></div>
        
        {/* Fallback background if video fails */}
        <div 
          className="absolute inset-0 w-full h-full bg-gradient-to-br from-blue-900 via-blue-800 to-indigo-900"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/a4f7dcb940166f036f434b243c79605d.jpg')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }}
        />
      </div>

      {/* All content sections with relative positioning to appear above video */}
      <div className="relative z-10">
        <Hero />
        <Services />
        <About />
        <Testimonials />
        <Contact />
        <Footer />
      </div>

      {/* AI Chat Widget */}
      <ChatWidget 
        apiEndpoint="https://voice.theinsurancedoctors.com/readdy-chat"
        apiKey=""
        agentName="Dr. Peterson's AI Assistant"
        welcomeMessage="Hi! I'm Dr. Peterson's AI assistant. How can I help today?"
      />
    </div>
  );
}
